import { AfterViewInit, Directive, ElementRef, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';
import { Control } from 'ol/control.js';
import { OLMapService } from '../../services/ol-map/ol-map.service';

@Directive({ selector: '[appMapLegend]', standalone: false })
export class MapLegendDirective implements AfterViewInit, OnDestroy {
  private subscription?: Subscription;
  private control?: Control;

  constructor(private element: ElementRef<HTMLElement>, private maps: OLMapService) {}

  ngAfterViewInit(): void {
    this.subscription = this.maps.mapReady$.subscribe(map => {
      this.control?.setMap(null);
      const element = this.element.nativeElement;
      element.classList.add('map-legend-control');
      this.control = new Control({ element });
      this.control.setMap(map);
    });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
    this.control?.setMap(null);
  }
}
